import { render, staticRenderFns } from "./gerenPaciente.vue?vue&type=template&id=07f79398&scoped=true"
import script from "./gerenPaciente.vue?vue&type=script&lang=js"
export * from "./gerenPaciente.vue?vue&type=script&lang=js"
import style0 from "./gerenPaciente.vue?vue&type=style&index=0&id=07f79398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f79398",
  null
  
)

export default component.exports